import { MeterDto } from 'src/Libs/flow/installation/api'
import { PlannedPowerMeterDeviceType, PlannedPowerMeterModel } from 'src/Libs/installations/models'

const plannedPowerMeterDtoToModelTransformer = (meter: Nullable<MeterDto>): PlannedPowerMeterModel | null => {
  if (meter.id === null) return null

  return {
    id: meter.id,
    deviceLinkId: meter.deviceLinkId ?? meter.id,
    deviceName: meter.deviceName ?? '',
    media: (meter.media ?? 'ModbusRTU') as PlannedPowerMeterModel['media'],
    mediaParameters: meter.mediaParameters ?? undefined,
    deviceType: (meter.deviceType ?? '') as PlannedPowerMeterDeviceType,
    typeParameters: meter.typeParameters ?? {},
    wiringMode: meter.wiringMode ?? 'Normal',
  }
}

export default plannedPowerMeterDtoToModelTransformer
